export enum GenderNames {
	Male = "male",
	Female = "female",
	Diverse = "divers",
}

export enum PermissionNames {
	CanManageAbsences = "manage-absences",
	CanViewAbsences = "view-absences",
	CanViewApiDocs = "view-api-docs",
	CanManageInvoices = "manage-invoices",
	CanManageProjects = "manage-projects",
	CanManageProjectTags = "manage-project-tags",
	CanManageStaff = "manage-staff",
	// Placeholder: the backend has not named the permission of the HR documents yet. Until then, it is the permission
	// that opens the HR section. The swap replaces this value.
	CanManageHrDocuments = "manage-staff",
	CanManagesStaffSalaries = "manage-staff-salaries",
	CanManageTimeTrackings = "manage-time-trackings",
	CanManageUsers = "manage-users",
	CanViewInvoices = "view-invoices",
	CanViewReports = "view-reports",
}

export enum RoleNames {
	Admin = "admin",
/*	ProjectManager = "project-manager",
	InvoiceManager = "invoice-manager",
	TeamMember = "team-member",
	HrManager = "hr-manager",*/
}

export enum WorkingStatusNames {
	Active = "active",
	Quotation = "quotation",
	Hold = "hold",
	Cancelled = "cancelled",
	Closed = "closed",
}

export enum TimeTrackingTypeNames {
	Project = "project",
	Internal = "internal",
	Sales = "sales",
	PartTime = "partTime",
}
